import React from "react";
import { Card } from "antd";
import { UsergroupAddOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Button } from "../../../components";

const AllForums = () => {
  return (
    <>
      <div>
        <Card className="sidebarCard">
          <div className="flex py-2 justify-between">
            <Link className="text-sm" to="forums">All Forums</Link>
            <p>13</p>
          </div>
          <div className="flex py-2 justify-between">
            <p className="text-sm">Suggested Forums</p>
          </div>
          <div>
            <Button
              type="default"
              className="mr-10 forumBtn"
              icon={<UsergroupAddOutlined style={{color: "#1890ff"}} />}
              title="Create Forum"
              style={{
                height: "40px",
                borderRadius: "30px",
                borderColor: "#1890ff",
              }}
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default AllForums;
